import React from 'react';
import styles from './css/index.module.css';

export default function WorkstreamChipList({ label, maxCollapsed = 10 }) {
    const [expanded, setExpanded] = React.useState(false);

    if (!label || label === 'None selected') {
        return <p className={styles.chipEmpty}>None selected</p>;
    }
    if (label === 'All workstreams') {
        return <span className={styles.scopeChip}>All workstreams</span>;
    }

    const names = label.split(' · ').map(item => item.trim()).filter(Boolean);
    const shouldCollapse = names.length > maxCollapsed;
    const visible = shouldCollapse && !expanded ? names.slice(0, maxCollapsed) : names;
    const hiddenCount = names.length - maxCollapsed;

    return (
        <div className={styles.chipRow}>
            {visible.map(name => (
                <span key={name} className={styles.workstreamChip}>
                    {name}
                </span>
            ))}
            {shouldCollapse && !expanded ? (
                <button type="button" className={styles.chipMoreBtn} onClick={() => setExpanded(true)}>
                    +{hiddenCount} more
                </button>
            ) : null}
            {shouldCollapse && expanded ? (
                <button type="button" className={styles.chipMoreBtn} onClick={() => setExpanded(false)}>
                    Show less
                </button>
            ) : null}
        </div>
    );
}
